var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{ref:"root",staticClass:"about-us-map mb6 flex justify-center"},[(_setup.showMap)?_c(_setup.BravadoMap):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }